import { SECTION_TYPE } from './sectionType';

export const errors = {
  default: 'Sorry, we couldn\'t get this information for you, please check back later!',
  [SECTION_TYPE.REGISTRATION_STATUS]: {
    default: 'Sorry, we couldn\'t retrieve your registration status, please check back later!',
    '404': 'There is no registration currently associated with your account.',
  },
}

export const loading = {
  default: 'Loading your information...',
  [SECTION_TYPE.REGISTRATION_STATUS]: 'Loading your registration status...',
  [SECTION_TYPE.ASR_STATUS]: 'Loading your after-sale repair case...',
}

export default {
  errors,
  loading,
};
